import React from "react";
import AnimatedDialogLayout from "./AnimatedDialogLayout";
import ButtonSpinner from "components/Loading/ButtonSpinner";

const RemoveWarningDialog = ({
  isOpen,
  isClose,
  warningText,
  onClick,
  loading = false,
  buttonText = "Rimuovi",
  buttonText2 = null,
}) => {
  return (
    <AnimatedDialogLayout isOpen={isOpen} onClose={isClose}>
      <div className="max-w-sm">
        <h1 className="text-black font-semibold text-[25px] mt-4 text-center leading-[35px]">
          {warningText}
        </h1>

        <div className="mt-5 w-full flex items-center space-x-3">
          {buttonText2 && (
            <button
              onClick={isClose}
              className={`bg-primary disabled:cursor-not-allowed text-white rounded-[11px] h-[51px] w-full grid justify-center items-center font-semibold text-[18px]`}
            >
              {buttonText2}
            </button>
          )}

          <button
            disabled={loading}
            onClick={onClick}
            className={`bg-red-600 disabled:cursor-not-allowed text-white rounded-[11px] h-[51px] w-full grid justify-center items-center font-semibold text-[18px]`}
          >
            {loading ? <ButtonSpinner /> : buttonText}
          </button>
        </div>
      </div>
    </AnimatedDialogLayout>
  );
};

export default RemoveWarningDialog;
